'use client';

import { AccordionComponent } from "@/payload-types";
import { useRef, useState } from "react";
import { RichText } from "../../ui/content/rich-text";
import { ArrowDown } from "../../ui/icons";
import clsx from "clsx";
import './styles.scss';
import { ArrayElement } from "@/payload-custom-types";
import { useInView } from "motion/react";

interface AccordionGroupTypes {
  accordionElements: AccordionComponent['accordionElements'];
};
type SingleAccordionElement = ArrayElement<NonNullable<AccordionComponent['accordionElements']>>;

const AccordionItem = ({ accordionElement, itemKey }: {
  accordionElement: SingleAccordionElement;
  itemKey: number;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleItem = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <li className={clsx('accordion-item', { 'is-open': isOpen })} style={{ transitionDelay: `${itemKey * 0.15}s` }}>
        <div className="accordion-item-wrapper">
          <button onClick={toggleItem}
            id={`accordion-item-${itemKey}`}
            className="accordion-button"
            aria-controls={`accordion-content-${itemKey}`}
            aria-expanded={isOpen}
          >
            { accordionElement?.heading && <span className="button-text">{accordionElement?.heading}</span> }
            <span className="accordion-button-icon">
              <ArrowDown color="#fff" className="accordion-title-icon" />
            </span>
          </button>                
          <div id={`accordion-content-${itemKey}`} className="accordion-content" role="tabpanel" aria-labelledby={`accordion-item-${itemKey}`} aria-hidden={!isOpen}>
            {accordionElement?.description && <RichText content={accordionElement.description} />}
          </div>
        </div>
      </li>
    </>
  );
}

export const AccordionGroup = ({ accordionElements }: AccordionGroupTypes) => {
  const containerRef = useRef<HTMLUListElement>(null);
  const isInView = useInView(containerRef, {
    once: true,
    amount: 0.4,
  });

  return (
    <>
      { accordionElements?.length ? (
        <ul ref={containerRef} className={clsx('accordion-group', isInView && 'in-view')}>
          { accordionElements?.map((accordionElement, index) => {
            return <AccordionItem key={index} itemKey={index} accordionElement={accordionElement} />;
          })}
        </ul>
      ) : null}
    </>
  );
};